export function checkDeleteImage(before?: (File | Image)[], after?: (File | Image)[]) {
  let result: string[] = [];
  if (before && after) {
    const beforeData = before.filter((temp) => (temp as Image).img_idx !== undefined);
    const afterData = after.filter((temp) => (temp as Image).img_idx !== undefined);
    const deleteImages = beforeData.filter((x) => !afterData.includes(x));
    result = deleteImages.map((image) => (image as Image).img_idx.toString());
  }
  return result;
}
